module.exports = __webpack_public_path__ + "img/75.88529a07.jpg";